// Textos de Contratações (31/10/2026), coletados por glob em core/i18n/messages.ts. Levam
// também os textos do cartão Controle de vagas da tela de Arquivos, pela chave `vagas`.
export default {
  pt: {
    'dp.vagas.titulo': 'Contratações',
    'dp.vagas.nova': 'Nova vaga',
    'dp.vagas.novaTitulo': 'Nova vaga',
    'dp.vagas.editarTitulo': 'Dados da vaga {{cargo}}',
    'dp.vagas.ajuda': 'Cada linha é uma vaga do controle de vagas do DP. Os dias em aberto contam da abertura até hoje, ou até o preenchimento. Cada indicador filtra a lista ao ser clicado.',
    'dp.vagas.busca': 'Buscar por vaga, gestor ou candidato',
    'dp.vagas.cargo': 'Vaga',
    'dp.vagas.gestor': 'Gestor',
    'dp.vagas.todosGestores': 'Todos os gestores',
    'dp.vagas.quantidade': 'Quantidade',
    'dp.vagas.cargaHoraria': 'Carga horária',
    'dp.vagas.salario': 'Salário',
    'dp.vagas.abertaEm': 'Abertura',
    'dp.vagas.preenchidaEm': 'Preenchimento',
    'dp.vagas.diasEmAberto': 'Dias em aberto',
    'dp.vagas.candidato': 'Candidato ou observação',
    'dp.vagas.matricula': 'Matrícula de quem foi admitido',
    'dp.vagas.matriculaAjuda': 'Liga a vaga ao colaborador no cadastro do Hub. Vazio desliga.',
    'dp.vagas.pessoa': 'Colaborador no Hub',
    'dp.vagas.semPessoa': 'Ainda sem colaborador no Hub',
    'dp.vagas.fase': 'Fase',
    'dp.vagas.fase.recrutamento': 'Recrutamento',
    'dp.vagas.fase.estudo_social': 'Estudo social',
    'dp.vagas.fase.entrevistas': 'Entrevistas',
    'dp.vagas.fase.aguardando_gestor': 'Aguardando gestor',
    'dp.vagas.fase.aguardando_aceite': 'Aguardando aceite',
    'dp.vagas.fase.preenchida': 'Preenchida',
    'dp.vagas.fase.cancelada': 'Cancelada',
    'dp.vagas.fases.abertas': 'Em aberto',
    'dp.vagas.fases.todas': 'Todas',
    'dp.vagas.kpi.emAberto': 'Em aberto',
    'dp.vagas.kpi.mais60': 'Mais de {{vagaAtencaoDias}} dias',
    'dp.vagas.kpi.mais90': 'Mais de {{vagaCriticoDias}} dias',
    'dp.vagas.kpi.aguardandoGestor': 'Aguardando gestor',
    'dp.vagas.kpi.preenchidasMes': 'Preenchidas no mês',
    'dp.vagas.col.vaga': 'Vaga',
    'dp.vagas.col.unidade': 'Unidade',
    'dp.vagas.col.gestor': 'Gestor',
    'dp.vagas.col.abertura': 'Abertura',
    'dp.vagas.col.fase': 'Fase',
    'dp.vagas.posicoes': '{{n}} posições',
    'dp.vagas.posicaoUma': '1 posição',
    'dp.vagas.dias': '{{dias}} dias em aberto',
    'dp.vagas.diaUm': '1 dia em aberto',
    'dp.vagas.diasAtePreencher': 'Preenchida em {{dias}} dias',
    'dp.vagas.faixa.mais_60': 'Mais de {{vagaAtencaoDias}} dias',
    'dp.vagas.faixa.mais_90': 'Mais de {{vagaCriticoDias}} dias',
    'dp.vagas.abrir': 'Abrir',
    'dp.vagas.editar': 'Editar dados',
    'dp.vagas.mudarFase': 'Mudar fase',
    'dp.vagas.preencher': 'Marcar preenchida',
    'dp.vagas.cancelar': 'Cancelar vaga',
    'dp.vagas.reabrir': 'Voltar ao funil',
    'dp.vagas.faseTitulo': 'Mudar a fase da vaga {{cargo}}',
    'dp.vagas.novaFase': 'Nova fase',
    'dp.vagas.justificativa': 'Justificativa',
    'dp.vagas.faseExplica.preenchida': 'Preenchida pede a data e, se a pessoa já estiver no Hub, a matrícula de quem foi admitido.',
    'dp.vagas.faseExplica.cancelada': 'Cancelar pede o motivo, que fica registrado. A planilha não reabre uma vaga cancelada.',
    'dp.vagas.faseExplica.volta': 'Voltar ao funil pede a justificativa, que fica registrada.',
    'dp.vagas.importarTitulo': 'Importar o controle de vagas',
    'dp.vagas.importarExplica': 'A aba Base da planilha de controle de vagas, com o resumo semanal em cima. Filial que não é do DP aparece como fora do escopo e não grava. A vaga que já existe, pela filial, vaga e data de abertura, é atualizada; a cancelada no Hub não volta. O salário só entra para quem vê dado sensível.',
    'dp.vagas.carga.emAberto': 'Em aberto',
    'dp.vagas.carga.preenchidas': 'Preenchidas',
    'dp.vagas.carga.salarioEmTexto': 'Salário em texto, anotado na observação',
    'dp.vagas.carga.semFase': 'Sem fase reconhecida',
    'dp.arquivos.nome.vagas': 'Controle de vagas',
    'dp.arquivos.subtitulo.vagas': 'Vagas em aberto',
    'dp.arquivos.marca.vagas': 'Contratações',
    'dp.arquivos.pendencia.vagas': '{{n}} linhas sem fase reconhecida.',
  },
  en: {
    'dp.vagas.titulo': 'Hiring',
    'dp.vagas.nova': 'New opening',
    'dp.vagas.novaTitulo': 'New opening',
    'dp.vagas.editarTitulo': 'Opening details, {{cargo}}',
    'dp.vagas.ajuda': 'Each row is an opening from the HR hiring control. Days open count from the opening date to today, or to the fill date. Each indicator filters the list when clicked.',
    'dp.vagas.busca': 'Search by opening, manager or candidate',
    'dp.vagas.cargo': 'Opening',
    'dp.vagas.gestor': 'Manager',
    'dp.vagas.todosGestores': 'All managers',
    'dp.vagas.quantidade': 'Quantity',
    'dp.vagas.cargaHoraria': 'Working hours',
    'dp.vagas.salario': 'Salary',
    'dp.vagas.abertaEm': 'Opened',
    'dp.vagas.preenchidaEm': 'Filled',
    'dp.vagas.diasEmAberto': 'Days open',
    'dp.vagas.candidato': 'Candidate or note',
    'dp.vagas.matricula': 'Employee ID of the person hired',
    'dp.vagas.matriculaAjuda': 'Links the opening to the employee in the Hub records. Empty unlinks.',
    'dp.vagas.pessoa': 'Employee in the Hub',
    'dp.vagas.semPessoa': 'No employee in the Hub yet',
    'dp.vagas.fase': 'Stage',
    'dp.vagas.fase.recrutamento': 'Recruiting',
    'dp.vagas.fase.estudo_social': 'Social study',
    'dp.vagas.fase.entrevistas': 'Interviews',
    'dp.vagas.fase.aguardando_gestor': 'Awaiting manager',
    'dp.vagas.fase.aguardando_aceite': 'Awaiting acceptance',
    'dp.vagas.fase.preenchida': 'Filled',
    'dp.vagas.fase.cancelada': 'Canceled',
    'dp.vagas.fases.abertas': 'Open',
    'dp.vagas.fases.todas': 'All',
    'dp.vagas.kpi.emAberto': 'Open',
    'dp.vagas.kpi.mais60': 'Over {{vagaAtencaoDias}} days',
    'dp.vagas.kpi.mais90': 'Over {{vagaCriticoDias}} days',
    'dp.vagas.kpi.aguardandoGestor': 'Awaiting manager',
    'dp.vagas.kpi.preenchidasMes': 'Filled this month',
    'dp.vagas.col.vaga': 'Opening',
    'dp.vagas.col.unidade': 'Branch',
    'dp.vagas.col.gestor': 'Manager',
    'dp.vagas.col.abertura': 'Opened',
    'dp.vagas.col.fase': 'Stage',
    'dp.vagas.posicoes': '{{n}} positions',
    'dp.vagas.posicaoUma': '1 position',
    'dp.vagas.dias': '{{dias}} days open',
    'dp.vagas.diaUm': '1 day open',
    'dp.vagas.diasAtePreencher': 'Filled in {{dias}} days',
    'dp.vagas.faixa.mais_60': 'Over {{vagaAtencaoDias}} days',
    'dp.vagas.faixa.mais_90': 'Over {{vagaCriticoDias}} days',
    'dp.vagas.abrir': 'Open',
    'dp.vagas.editar': 'Edit details',
    'dp.vagas.mudarFase': 'Change stage',
    'dp.vagas.preencher': 'Mark as filled',
    'dp.vagas.cancelar': 'Cancel opening',
    'dp.vagas.reabrir': 'Back to the pipeline',
    'dp.vagas.faseTitulo': 'Change the stage of {{cargo}}',
    'dp.vagas.novaFase': 'New stage',
    'dp.vagas.justificativa': 'Justification',
    'dp.vagas.faseExplica.preenchida': 'Filled needs the date and, if the person is already in the Hub, the employee ID of who was hired.',
    'dp.vagas.faseExplica.cancelada': 'Canceling needs the reason, which is recorded. The spreadsheet does not reopen a canceled opening.',
    'dp.vagas.faseExplica.volta': 'Going back to the pipeline needs a justification, which is recorded.',
    'dp.vagas.importarTitulo': 'Import the hiring control',
    'dp.vagas.importarExplica': 'The Base sheet of the hiring control spreadsheet, with the weekly summary on top. Branches outside HR scope show as out of scope and are not saved. An opening that already exists, by branch, opening and opening date, is updated; one canceled in the Hub does not come back. Salary is only saved for those who see sensitive data.',
    'dp.vagas.carga.emAberto': 'Open',
    'dp.vagas.carga.preenchidas': 'Filled',
    'dp.vagas.carga.salarioEmTexto': 'Salary as text, kept in the note',
    'dp.vagas.carga.semFase': 'Stage not recognized',
    'dp.arquivos.nome.vagas': 'Hiring control',
    'dp.arquivos.subtitulo.vagas': 'Open positions',
    'dp.arquivos.marca.vagas': 'Hiring',
    'dp.arquivos.pendencia.vagas': '{{n}} rows without a recognized stage.',
  },
  es: {
    'dp.vagas.titulo': 'Contrataciones',
    'dp.vagas.nova': 'Nueva vacante',
    'dp.vagas.novaTitulo': 'Nueva vacante',
    'dp.vagas.editarTitulo': 'Datos de la vacante {{cargo}}',
    'dp.vagas.ajuda': 'Cada línea es una vacante del control de vacantes del DP. Los días abiertos cuentan desde la apertura hasta hoy, o hasta la cobertura. Cada indicador filtra la lista al hacer clic.',
    'dp.vagas.busca': 'Buscar por vacante, gestor o candidato',
    'dp.vagas.cargo': 'Vacante',
    'dp.vagas.gestor': 'Gestor',
    'dp.vagas.todosGestores': 'Todos los gestores',
    'dp.vagas.quantidade': 'Cantidad',
    'dp.vagas.cargaHoraria': 'Carga horaria',
    'dp.vagas.salario': 'Salario',
    'dp.vagas.abertaEm': 'Apertura',
    'dp.vagas.preenchidaEm': 'Cobertura',
    'dp.vagas.diasEmAberto': 'Días abiertos',
    'dp.vagas.candidato': 'Candidato u observación',
    'dp.vagas.matricula': 'Matrícula de quien fue admitido',
    'dp.vagas.matriculaAjuda': 'Vincula la vacante al colaborador en el registro del Hub. Vacío desvincula.',
    'dp.vagas.pessoa': 'Colaborador en el Hub',
    'dp.vagas.semPessoa': 'Aún sin colaborador en el Hub',
    'dp.vagas.fase': 'Fase',
    'dp.vagas.fase.recrutamento': 'Reclutamiento',
    'dp.vagas.fase.estudo_social': 'Estudio social',
    'dp.vagas.fase.entrevistas': 'Entrevistas',
    'dp.vagas.fase.aguardando_gestor': 'Esperando al gestor',
    'dp.vagas.fase.aguardando_aceite': 'Esperando aceptación',
    'dp.vagas.fase.preenchida': 'Cubierta',
    'dp.vagas.fase.cancelada': 'Cancelada',
    'dp.vagas.fases.abertas': 'Abiertas',
    'dp.vagas.fases.todas': 'Todas',
    'dp.vagas.kpi.emAberto': 'Abiertas',
    'dp.vagas.kpi.mais60': 'Más de {{vagaAtencaoDias}} días',
    'dp.vagas.kpi.mais90': 'Más de {{vagaCriticoDias}} días',
    'dp.vagas.kpi.aguardandoGestor': 'Esperando al gestor',
    'dp.vagas.kpi.preenchidasMes': 'Cubiertas en el mes',
    'dp.vagas.col.vaga': 'Vacante',
    'dp.vagas.col.unidade': 'Unidad',
    'dp.vagas.col.gestor': 'Gestor',
    'dp.vagas.col.abertura': 'Apertura',
    'dp.vagas.col.fase': 'Fase',
    'dp.vagas.posicoes': '{{n}} puestos',
    'dp.vagas.posicaoUma': '1 puesto',
    'dp.vagas.dias': '{{dias}} días abiertos',
    'dp.vagas.diaUm': '1 día abierto',
    'dp.vagas.diasAtePreencher': 'Cubierta en {{dias}} días',
    'dp.vagas.faixa.mais_60': 'Más de {{vagaAtencaoDias}} días',
    'dp.vagas.faixa.mais_90': 'Más de {{vagaCriticoDias}} días',
    'dp.vagas.abrir': 'Abrir',
    'dp.vagas.editar': 'Editar datos',
    'dp.vagas.mudarFase': 'Cambiar fase',
    'dp.vagas.preencher': 'Marcar cubierta',
    'dp.vagas.cancelar': 'Cancelar vacante',
    'dp.vagas.reabrir': 'Volver al embudo',
    'dp.vagas.faseTitulo': 'Cambiar la fase de la vacante {{cargo}}',
    'dp.vagas.novaFase': 'Nueva fase',
    'dp.vagas.justificativa': 'Justificación',
    'dp.vagas.faseExplica.preenchida': 'Cubierta pide la fecha y, si la persona ya está en el Hub, la matrícula de quien fue admitido.',
    'dp.vagas.faseExplica.cancelada': 'Cancelar pide el motivo, que queda registrado. La planilla no reabre una vacante cancelada.',
    'dp.vagas.faseExplica.volta': 'Volver al embudo pide la justificación, que queda registrada.',
    'dp.vagas.importarTitulo': 'Importar el control de vacantes',
    'dp.vagas.importarExplica': 'La hoja Base de la planilla de control de vacantes, con el resumen semanal arriba. La sucursal que no es del DP aparece como fuera del alcance y no se graba. La vacante que ya existe, por sucursal, vacante y fecha de apertura, se actualiza; la cancelada en el Hub no vuelve. El salario solo entra para quien ve dato sensible.',
    'dp.vagas.carga.emAberto': 'Abiertas',
    'dp.vagas.carga.preenchidas': 'Cubiertas',
    'dp.vagas.carga.salarioEmTexto': 'Salario en texto, anotado en la observación',
    'dp.vagas.carga.semFase': 'Sin fase reconocida',
    'dp.arquivos.nome.vagas': 'Control de vacantes',
    'dp.arquivos.subtitulo.vagas': 'Vacantes abiertas',
    'dp.arquivos.marca.vagas': 'Contrataciones',
    'dp.arquivos.pendencia.vagas': '{{n}} líneas sin fase reconocida.',
  },
}
